export default function Hero() {
  return (
    <section className="relative bg-plum overflow-hidden pt-16 md:pt-20">
      <div className="w-full flex flex-col lg:flex-row min-h-[480px] md:min-h-[560px] max-w-[1280px] mx-auto">
        {/* Left text */}
        <div className="w-full lg:w-[55%] flex flex-col justify-center px-4 md:px-8 lg:px-12 py-8 md:py-12 lg:py-16">
          <div className="max-w-2xl">
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-serif font-bold text-white leading-tight mb-4 md:mb-6">
              Réparation de fenêtre à Sélestat
            </h1>
            <p className="md:hidden text-base text-white/80 leading-relaxed mb-4">
              Fenêtre qui ferme mal, bloquée, crémone ou poignée cassée à Sélestat ? Réparation à domicile, pièce comprise, devis gratuit.
            </p>
            <p className="hidden md:block text-base md:text-lg text-white/80 leading-relaxed mb-6 md:mb-8">
              Sélestat, au cœur du vignoble et au pied des Vosges, allie patrimoine médiéval et résidences contemporaines. Des maisons à colombages aux constructions récentes, chaque fenêtre mérite une réparation soignée. Nous intervenons à domicile, pièce comprise.
            </p>
            <div className="md:hidden flex flex-wrap gap-x-3 gap-y-1 mb-4 text-white/70 text-xs">
              <span className="whitespace-nowrap">Intervention 24h</span>
              <span className="text-white/40">·</span>
              <span className="whitespace-nowrap">Devis &amp; déplacement gratuits</span>
              <span className="text-white/40">·</span>
              <span className="whitespace-nowrap">Pièce comprise</span>
              <span className="text-white/40">·</span>
              <span className="whitespace-nowrap">Garantie 10 ans</span>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
              <a
                href="tel:0374471036"
                className="inline-flex items-center justify-center gap-2 bg-coral text-white px-6 py-4 rounded-xl font-semibold text-base whitespace-nowrap hover:bg-coral-light transition-colors"
              >
                <i className="ri-phone-line" />
                Appeler le 03 74 47 10 36
              </a>
              <a
                href="#devis"
                className="inline-flex items-center justify-center gap-2 border-2 border-white/30 text-white px-6 py-4 rounded-xl font-semibold text-base whitespace-nowrap hover:bg-white/10 transition-colors"
              >
                <i className="ri-edit-line" />
                Devis gratuit
              </a>
            </div>
          </div>
        </div>
        {/* Right image */}
        <div className="w-full lg:w-[45%] relative min-h-[280px] md:min-h-[400px] lg:min-h-0">
          <div className="absolute inset-0 m-4 md:m-6 lg:m-8 rounded-2xl overflow-hidden">
            <img
              src="https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/a5678743fe9ccf4d4061d6534d54e38d.jpeg"
              alt="Réparation de fenêtre à Sélestat"
              className="w-full h-full object-cover object-top"
              loading="eager"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-plum/40 to-transparent lg:hidden" />
          </div>
        </div>
      </div>

      {/* Reassurance bar */}
      <div className="hidden md:block bg-white/5 border-t border-white/10">
        <div className="w-full px-4 md:px-8 lg:px-12 py-4 md:py-5 max-w-[1280px] mx-auto">
          <div className="flex flex-wrap items-center justify-center gap-x-6 md:gap-x-10 gap-y-2 text-white/80 text-sm">
            <span className="flex items-center gap-2">
              <i className="ri-time-line text-coral" />
              Intervention 24h
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-file-list-3-line text-coral" />
              Devis & déplacement gratuits
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-shield-check-line text-coral" />
              Toutes marques
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-award-line text-coral" />
              Garantie 10 ans
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}